// test2561
(2561 && 0);
